<i2a-profile-card [id]="id" [title]="title" (onWarnClick)="warnClick($event)" [hasAlert]="hasAlert"
  [hasAlertRecentlyClosed]="hasAlertRecentlyClosed" [warningLevel]="warningLevel">
  <ng-container picto>
    <i2a-resource-photo [providerInstanceResource]="permissions.providerInstanceResource" [size]="40">
    </i2a-resource-photo>
  </ng-container>
  <ng-container subTitleContent>
    <i2a-mailing-permission-rights [permissions]="permissions"></i2a-mailing-permission-rights>
  </ng-container>
</i2a-profile-card>